import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpService} from "../../../service/http.service";
declare var $: any;
@Component({
  selector: 'app-promocode',
  templateUrl: './promocode.component.html',
  styleUrls: ['./promocode.component.css']

})
export class PromocodeComponent implements OnInit {

  promoForm: FormGroup;
  editPromoForm:FormGroup;
  isPromoSaved = false;
  isPromoError = false;
  isEditPromoSaved = false;
  isEditPromoError = false;
  promoData = [];
  promoId;

  constructor(private http: HttpService) { }

  ngOnInit() {

    this.promoForm = new FormGroup({
      promoCode: new FormControl('',[Validators.required, Validators.pattern(/^[a-z0-9]+$/i)]),
      duration: new FormControl('',[Validators.required, Validators.pattern('^[1-9][0-9]*$')]),
      expirationDate: new FormControl('',[Validators.required])
    });

    this.editPromoForm = new FormGroup({
      promoCode: new FormControl('',[Validators.required, Validators.pattern(/^[a-z0-9]+$/i)]),
      duration: new FormControl('',[Validators.required, Validators.pattern('^[1-9][0-9]*$')]),
      expirationDate: new FormControl('',[Validators.required])
    });

    var that = this;
    $('window').ready(function(){
      // $('.exp_datepicker').click(function () {
      //   $('.modal-open').find('.exp_datepicker').datepicker();
      //   var cs=$('.exp_datepicker').datepicker();
      //   console.log(cs);
      // })
      // $('.exp_datepicker1').click(function () {
      //   $('.modal-open').find('.exp_datepicker1').datepicker();
      // })
      
      $('#ex_date').datepicker({
        minDate: 1,
        onSelect: (dateText, inst) => {
          console.log('dateText : ', dateText);
          that.promoForm.controls['expirationDate'].setValue(dateText);
        }
      });

      $('#ex_date_edit').datepicker({
        minDate: 1,
        onSelect: (dateText, inst) => {
          console.log('dateText : ', dateText);
          that.editPromoForm.controls['expirationDate'].setValue(dateText);
        }
      });

    });

   

    this.http.getPromoCode().subscribe(
      (data) => {
        console.log('Get Promo Code', data);
        this.promoData = data.promoCode;
      }
    );

  }

  onPromoSubmit(){
    console.log(this.promoForm.valid, this.promoForm.value);

    if(this.promoForm.valid){
      var promocode = this.promoForm.value;
      promocode.expirationDate = new Date(this.promoForm.value.expirationDate)
      console.log('Promo Code : ', promocode);

      this.http.savePromoCode(promocode).subscribe(
        (data) => {
          console.log(data);
          
          if(data.status) {
            this.isPromoSaved = true;
            this.isPromoError = false;
            this.promoData.push(data.promo);
            $('.main_content').show();
          }else {
            this.isPromoError = true;
            this.isPromoSaved = false;
          }

          setTimeout(
            () => {
              $('#addpromo .close').trigger('click');
              this.isPromoError = false;
              this.isPromoSaved = false;
              this.promoForm.reset();
            }, 2000
          );
        }
      );
    }
  }

  editPromoCode(promo){
    var promoCode = promo.promoCode;
    this.editPromoForm.get('promoCode').patchValue(promoCode);
    this.editPromoForm.get('duration').patchValue(promo.duration);
    var exDate = new Date(promo.expirationDate).toLocaleDateString('en-US').slice(0,10);
    this.editPromoForm.get('expirationDate').patchValue(exDate);
    this.promoId = promo.id;
  }

  onEditPromoFormSubmit(){
    console.log(this.editPromoForm.valid, this.editPromoForm.value);
    let data = this.editPromoForm.value;
    data.expirationDate = new Date( this.editPromoForm.value.expirationDate)
    const formData = data;
    formData.id = this.promoId;
    console.log('formData', formData);

    // Update Promo Code
    if(this.editPromoForm.valid) {
      this.http.updatePromoCode(formData).subscribe(
        (data) => {
          this.promoId = null;
          console.log(data);
          if(data.status){
            this.isEditPromoSaved = true;
            this.isEditPromoError = false;
            this.promoData = data.promo;
            $('.main_content').show();
          }else {
            this.isEditPromoSaved = false;
            this.isEditPromoError = true;
          }
          setTimeout(
            () => {
              this.isEditPromoSaved = false;
              this.isEditPromoError = false;
              $('#editpromo').find('button.close').trigger('click');
            }, 2000
          );
        }
      );
    }
  }

  removePromoCode(promoId) {
    console.log(promoId);
    this.http.deletePromoCode(promoId).subscribe(
      (data) => {
        if(data.status) {
          this.promoData = this.promoData.filter(item=>item.id !== data.promo[0].id)
          //$('.main_content').hide(500);
        }
      }
    );
  }

}
